export default {
    /**
     * Get limit and consomation for the current corp
     *
     * @returns {Promise}
     */
    getQuotasAndCredits() {
        return window.ApiClient.get('/quotas');
    },

    /**
     * Get detail of the subscription
     *
     * @returns {Promise}
     */
    getSubscription() {
        return window.ApiClient.get('/settings/subscription');
    },

    /**
     * Get detail of the subscription
     * @todo missing: licences
     * @returns {Promise}
     */
    getStaffs(paginationParams) {
        const field = ['id', 'firstname', 'lastname', 'position', 'avatar', '_embed'];
        return window.ApiClient.get('settings/staffs', {
            field: field,
            embed: ['licenses'],
            order: 'name',
            offset: paginationParams.offset,
            limit: paginationParams.limit,
        });
    },

    /**
     * Set license for staff
     * @returns {Promise}
     */
    putLicenseForStaff(staffId, licenseId) {
        const param = [];
        if (licenseId !== null) {
            param.push({ id: licenseId });
        }
        return window.ApiClient.put(`/staffs/${staffId}/licenses`, {}, param);
    },

    /**
     * Get subscription documents for the current corp
     * @returns Array
     */
    async getDocuments() {
        const params = { order: 'date', direction: 'desc', limit: 100 };
        let result = await window.ApiClient.get(`/accounts/documents`, params);
        if (typeof result?.data?.data === 'undefined') {
            return [];
        }
        const documents = result.data.data;
        while (documents.length < result.data.pagination.total) {
            result = await window.ApiClient.get(`/accounts/documents`, {
                ...params,
                offset: result.data.pagination.offset,
            });
            documents.push(...result.data.data);
        }
        return documents;
    },

    /**
     * Get Licences distributions on staff for Corp
     * @param { cartId: string }
     * @returns {Promise<Array<{code: string, staff: ID}>>}
     */
    getLicencesDistribution(cartId) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/sellsy-account-manager/cart/${cartId}/licenses-distributions`,
                {},
                (done) => {
                    resolve(done);
                },
                (err) => {
                    reject(err);
                },
            );
        });
    },
};
